import React from "react";
import {Helmet} from 'react-helmet';
import {Link} from "react-router-dom";
import {Header} from './Header';
import {Footer} from './Footer';
import {notFoundTexts} from "../libs/texts-not-found-lib";
import {getLanguageFromPath} from "../utils/language";
import "./NotFound.css";

function getHomePathForLanguage(language) {
    const paths = {
        EN: '/home',
        'EN-CA': '/en-ca/home',
        DE: '/de/home',
        FR: '/fr-ch/home',
        'FR-FR': '/fr/home',
        'FR-CA': '/fr-ca/home',
        NL: '/nl/home',
        IT: '/it/home',
        CZ: '/cz/home',
        FI: '/fi/home',
        PL: '/pl/home',
        SE: '/se/home',
        NO: '/nb/home',
        DK: '/dk/home',
        ES: '/es/home',
    };
    return paths[language] || '/home';
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const pathname = (props.location && props.location.pathname) || window.location.pathname;
    const language = getLanguageFromPath(pathname) || props.language || 'EN';
    const texts = notFoundTexts[language] || notFoundTexts.EN;
    const childProps = { ...props, language };
    const homePath = getHomePathForLanguage(language);
    const htmlLang = texts.htmlLang || 'en';

    return (
        <div className="not-found-page">
            <Helmet>
                <html lang={htmlLang} />
                <title>{texts.title} | CamDiab</title>
            </Helmet>
            <Header props={childProps} />
            <section className="not-found-content">
                <div className="not-found-inner">
                    <h1 className="not-found-title">{texts.title}</h1>
                    <p className="not-found-message">{texts.message}</p>
                    <Link className="not-found-home-link" to={homePath}>
                        {texts.homeCta}
                    </Link>
                </div>
            </section>
            <Footer props={childProps} />
        </div>
    );
};
